import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
import { computed, onMounted, onUnmounted, ref, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import CardSection from '@/components/Common/CardSection.vue';
import { storeToRefs } from 'pinia';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import { objDeepCompare } from '@/utils/object';
import InputRow from '@/components/Form/InputRow.vue';
import { createDistributorNoticeFormRule } from '@/form/form-rules/distributorNotice';
import { pStore } from '@/pinia';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { getFormValueForPinia, setFormValueForPinia, } from '@/utils/form';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 총판점 공지사항 등록, 수정
        const route = useRoute();
        const router = useRouter();
        const pDistributorNotice = pStore.piniaDistributorNotice;
        const pGlobal = pStore.piniaGlobal;
        const { formData, originFormData, } = storeToRefs(pDistributorNotice);
        const { urlHistory, } = storeToRefs(pGlobal);
        const isDistUser = computed(() => vuexStore.getters['user/isDistUser']);
        const formRule = createDistributorNoticeFormRule();
        const formRef = ref(null);
        /** pageId가 존재하면 수정페이지임 */
        const pageId = route.params.distributorNoticeId;
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = async () => {
            const isSameData = objDeepCompare(originFormData.value, formData.value);
            if (isSameData) {
                router.push({
                    name: routeName.DISTRIBUTOR_NOTICE,
                }).catch(() => { });
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: i18n.t('common.cancel'),
                bodyContent: i18n.t('common.confirm_before_cancel'),
            });
            if (!isConfirmOk) {
                return;
            }
            router.push({
                name: routeName.DISTRIBUTOR_NOTICE,
            }).catch(() => { });
        };
        /**
         * 취소 클릭 핸들러
         */
        const handleClickCancelBtn = async () => {
            const isSameData = objDeepCompare(originFormData.value, formData.value);
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            // eslint-disable-next-line no-nested-ternary
            const pageName = pageId
                ? urlHistory.value === routeName.DISTRIBUTOR_NOTICE
                    ? routeName.DISTRIBUTOR_NOTICE
                    : routeName.DISTRIBUTOR_NOTICE_DETAIL
                : routeName.DISTRIBUTOR_NOTICE;
            const params = pageId
                ? {
                    distributorNoticeId: pageId,
                }
                : {};
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const routeData = {
                name: pageName,
                query: route.query,
                params,
            };
            if (isSameData) {
                router.push(routeData).catch(() => { });
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: i18n.t('common.cancel'),
                bodyContent: i18n.t('common.confirm_before_cancel'),
            });
            if (isConfirmOk) {
                router.push(routeData).catch(() => { });
            }
        };
        /**
         * 전송
         */
        const handleSubmitForm = async () => {
            const { valid } = await formRef.value.validate();
            if (!valid) {
                return;
            }
            // api 호출
            try {
                const result = pageId
                    ? await pDistributorNotice.updateNotice()
                    : await pDistributorNotice.createNotice();
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.DISTRIBUTOR_NOTICE_DETAIL,
                    params: {
                        distributorNoticeId: pageId || result.data.id,
                    },
                    query: route.query,
                }).catch(() => { });
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        onMounted(async () => {
            // 조회
            if (pageId) {
                const response = await pDistributorNotice.getNotice(pageId);
                pDistributorNotice.setFormData(response);
            }
        });
        onUnmounted(() => {
            pDistributorNotice.clear();
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(SubController),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CardSection, null, {
                                titleContent: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        label: _unref(i18n).t('common.text_title')
                                    }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 제목 "),
                                            _createVNode(_component_v_text_field, {
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                maxlength: 35,
                                                "validate-on": "blur",
                                                rules: _unref(formRule).title,
                                                placeholder: "제목을 입력해 주세요.",
                                                "model-value": getFormValue('title'),
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('title', value))
                                            }, null, 8 /* PROPS */, ["rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        label: _unref(i18n).t('common.text_body')
                                    }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 본문 "),
                                            _createVNode(_component_v_textarea, {
                                                class: "cy-body",
                                                "validate-on": "blur",
                                                "model-value": getFormValue('body'),
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => setFormValue('body', value)),
                                                maxlength: 1400,
                                                rules: _unref(formRule).body,
                                                variant: "outlined",
                                                rows: "10",
                                                "row-height": "20",
                                                "hide-details": "auto",
                                                placeholder: "본문을 입력해 주세요."
                                            }, null, 8 /* PROPS */, ["model-value", "rules"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createCommentVNode(" footer "),
                        _createVNode(BoardFooter, null, {
                            left: _withCtx(() => [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                _createTextVNode(" mdi-chevron-left ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [2]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            right: _withCtx(() => [
                                (isDistUser.value)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        onClick: handleClickCancelBtn
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(i18n).t('common.cancel')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })), [
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                info: true,
                                                outlined: true,
                                                "size-l": true,
                                                "width-xs": true
                                            }
                                        ]
                                    ])
                                    : _createCommentVNode("v-if", true),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    type: "submit",
                                    class: "cy-submit-btn ml-2"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createTextVNode(" mdi-check ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [3]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.done')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
